import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import de from './de.json'
import tr from './tr.json'
import type { Language } from '../types'

const dictionaries = { de, tr } as const
type Dictionary = typeof de

interface I18nValue {
  language: Language
  setLanguage: (language: Language) => void
  t: (path: string) => string
  dictionary: Dictionary
}

const I18nContext = createContext<I18nValue | null>(null)

function readPath(dictionary: Dictionary, path: string) {
  const value = path.split('.').reduce<unknown>((current, key) => {
    if (!current || typeof current !== 'object') return undefined
    return (current as Record<string, unknown>)[key]
  }, dictionary)
  return typeof value === 'string' ? value : path
}

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguageState] = useState<Language>(() => localStorage.getItem('feedback-language') === 'de' ? 'de' : 'tr')
  const setLanguage = (next: Language) => { localStorage.setItem('feedback-language', next); setLanguageState(next) }
  useEffect(() => { document.documentElement.lang = language }, [language])
  const value = useMemo<I18nValue>(() => ({ language, setLanguage, dictionary: dictionaries[language], t: (path) => readPath(dictionaries[language], path) }), [language])
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>
}

export function useI18n() {
  const value = useContext(I18nContext)
  if (!value) throw new Error('I18nProvider fehlt.')
  return value
}
